import { makeAutoObservable } from 'mobx'

class ModalState {
    isOrderFormOpen = false;

    isLoginFormOpen = false;
    loginFormInitial = 'login';
    loginFormRedirect = '/profile';

    isResetPasswordFormOpen = false;
    isChangePasswordFormOpen = false;
    isFeedbackFormOpen = false;
    isOfficeMapOpen = false;
    isSpecialistOrderFormOpen = false;

    isCheckoutFormSuccessOpen = false;
    isPickupInfoOpen = false;

    isSpecialistAddressInfoOpen = false;
    specialistAddressInfo = null;

    isCertificateFormOpen = false;
    certificatePrice = Infinity;

    isCourseFormOpen = false;
    coursePrice = Infinity;
    courseDigitalId = null;
    courseTitle = '';

    isUpdateBalanceFormOpen = false;

    isPaymentCardFormOpen = false;
    paymentCardPrice = Infinity;
    paymentCardId = null;

    isKZLoginFormOpen = false;
    kzLoginCallback = () => {};

    isCancelFormOpen = false;
    cancelFormSettings = {};

    isTransferFormOpen = false;
    transferFormSettings = {};

    isOfficePayOrderFormOpen = false;
    officePayOrderFormSettings = {};

    isOfficePayPurchaseFormOpen = false;
    officePayPurchaseFormSettings = {};

    isFinishPaymentModalOpen = false;
    finishPaymentModalResponse = { title: '', text: '' };

    constructor(model) {
        this.model = model;
        makeAutoObservable(this, {
            model: false
        });
    }

    openOrderForm = () => {
        this.isOrderFormOpen = true;
    }

    closeOrderForm = () => {
        this.isOrderFormOpen = false;
    }

    openLoginForm = ({initial = 'login', redirect = '/profile'}) => {
        this.loginFormInitial = initial;
        this.isLoginFormOpen = true;
        this.loginFormRedirect = redirect;
    }

    closeLoginForm = () => {
        this.isLoginFormOpen = false;
        this.loginFormInitial = 'login';
        this.loginFormRedirect = '/profile';
    }

    openResetPasswordForm = () => {
        this.isResetPasswordFormOpen = true;
    }

    closeResetPasswordForm = () => {
        this.isResetPasswordFormOpen = false;
    }

    openChangePasswordForm = () => {
        this.isChangePasswordFormOpen = true;
    }

    closeChangePasswordForm = () => {
        this.isChangePasswordFormOpen = false;
    }

    openFeedbackForm = () => {
        this.isFeedbackFormOpen = true;
    }

    closeFeedbackForm = () => {
        this.isFeedbackFormOpen = false;
    }

    openOfficeMap = () => {
        this.isOfficeMapOpen = true;
    }

    closeOfficeMap = () => {
        this.isOfficeMapOpen = false;
    }

    openSpecialistOrderForm = (id) => {
        this.model.specialistOrderForm.setSpecialist(id);
        this.isSpecialistOrderFormOpen = true;
    }

    closeSpecialistOrderForm = () => {
        this.isSpecialistOrderFormOpen = false;
    }

    openCheckoutFormSuccess = () => {
        this.isCheckoutFormSuccessOpen = true;
    }

    closeCheckoutFormSuccess = () => {
        this.isCheckoutFormSuccessOpen = false;
    }

    openPickupInfo = () => {
        this.isPickupInfoOpen = true;
    }

    closePickupInfo = () => {
        this.isPickupInfoOpen = false;
    }

    openSpecialistAddressInfo = (address) => {
        this.isSpecialistAddressInfoOpen = true;
        this.specialistAddressInfo = address;
    }

    closeSpecialistAddressInfo = () => {
        this.specialistAddressInfo = null;
        this.isSpecialistAddressInfoOpen = false;
    }

    openCertificateForm = (price) => {
        this.certificatePrice = price;
        this.isCertificateFormOpen = true;
    }

    closeCertificateForm = () => {
        this.certificatePrice = Infinity;
        this.isCertificateFormOpen = false;
    }

    openCourseForm = ({ price, digitalId, title }) => {
        if (!window.isRuDomain && !this.model.user.isAuthenticated) {
            this.isKZLoginFormOpen = true;
            this.kzLoginCallback = () => {
                this.coursePrice = price;
                this.courseDigitalId = digitalId;
                this.courseTitle = title;
                this.isCourseFormOpen = true;
            }
        } else {
            this.coursePrice = price;
            this.courseDigitalId = digitalId;
            this.courseTitle = title;
            this.isCourseFormOpen = true;
        }
    }

    closeCourseForm = () => {
        this.isCourseFormOpen = false;
        this.coursePrice = Infinity;
        this.courseDigitalId = null;
    }

    openUpdateBalanceForm = () => {
        this.isUpdateBalanceFormOpen = true;
    }

    closeUpdateBalanceForm = () => {
        this.isUpdateBalanceFormOpen = false;
    }

    openPaymentCardForm = ({ price, cardId }) => {
        this.paymentCardPrice = price;
        this.paymentCardId = cardId;
        this.isPaymentCardFormOpen = true;
    }

    closePaymentCardForm = () => {
        this.isPaymentCardFormOpen = false;
        this.paymentCardPrice = Infinity;
        this.paymentCardId = null;
    }

    openKZLoginForm = (callback) => {
        console.log(callback);
        this.isKZLoginFormOpen = true;
        this.kzLoginCallback = callback;
    }

    closeKZLoginForm = () => {
        this.isKZLoginFormOpen = false;
        this.kzLoginCallback = () => {};
    }

    openCancelForm = ({ ticketId, orderId, meetingType, refundSum }) => {
        this.isCancelFormOpen = true;
        this.cancelFormSettings = {
            ticketId,
            orderId,
            refundSum,
            meetingType
        }
    }

    closeCancelForm = () => {
        this.isCancelFormOpen = false;
        this.cancelFormSettings = {};
    }

    openTransferForm = ({ specId, orderId, meetingType, utcDate }) => {
        this.isTransferFormOpen = true;
        this.transferFormSettings = {
            specId, meetingType, orderId, utcDate
        };
    }

    closeTransferForm = () => {
        this.isTransferFormOpen = false;
        this.transferFormSettings = {};
    }

    openOfficePayOrderForm = ({ orderId, ticketId, visits, service }) => {
        this.isOfficePayOrderFormOpen = true;
        this.officePayOrderFormSettings = {
            orderId, ticketId, visits, service
        };
    }

    closeOfficePayOrderForm = () => {
        this.isOfficePayOrderFormOpen = false;
        this.officePayOrderFormSettings = {};
    }

    openOfficePayPurchaseForm = ({ pk, url, price, isDigital }) => {
        this.isOfficePayPurchaseFormOpen = true;
        this.officePayPurchaseFormSettings = { pk, url, price, isDigital };
    }

    closeOfficePayPurchaseForm = () => {
        this.isOfficePayPurchaseFormOpen = false;
        this.officePayPurchaseFormSettings = {};
    }

    openFinishPaymentModal = ({ title, text }) => {
        this.isFinishPaymentModalOpen = true;
        this.finishPaymentModalResponse = { title, text };
    }

    closeFinishPaymentModal = () => {
        this.isFinishPaymentModalOpen = false;
        this.finishPaymentModalResponse = { title: '', text: ''};
    }

    reset = () => {
        this.isOrderFormOpen = false;

        this.isLoginFormOpen = false;
        this.loginFormRedirect = '/profile';
        this.loginFormInitial = 'login';

        this.isResetPasswordFormOpen = false;
        this.isChangePasswordFormOpen = false;
        this.isFeedbackFormOpen = false;
        this.isOfficeMapOpen = false;
        this.isSpecialistOrderFormOpen = false;

        this.isCheckoutFormSuccessOpen = false;
        this.isPickupInfoOpen = false;

        this.isSpecialistAddressInfoOpen = false;
        this.specialistAddressInfo = null;

        this.isCertificateFormOpen = false;
        this.certificatePrice = Infinity;

        this.isCourseFormOpen = false;
        this.coursePrice = Infinity;
        this.courseDigitalId = null;
        this.courseTitle = '';

        this.isUpdateBalanceFormOpen = false;

        this.isPaymentCardFormOpen = false;
        this.paymentCardPrice = Infinity;
        this.paymentCardId = null;

        this.isKZLoginFormOpen = false;
        this.kzLoginCallback = () => {};

        this.isCancelFormOpen = false;
        this.cancelFormSettings = {};

        this.isTransferFormOpen = false;
        this.transferFormSettings = {};

        this.isOfficePayOrderFormOpen = false;
        this.officePayOrderFormSettings = {};

        this.isOfficePayPurchaseFormOpen = false;
        this.officePayPurchaseFormSettings = {};

        this.isFinishPaymentModalOpen = false;
        this.finishPaymentModalResponse = { title: '', text: '' }
    }
}

export default ModalState;
